import React from 'react'
import { unSlugify } from '../../utils'

const StatusPill = ({status}) => {
    return (
        <span className={`inline-block text-xs px-2 py-1 rounded 
        ${status === 'pending' && 'bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize'}
        ${status === 'in-progress' && 'bg-amber-600 text-amber-800 bg-opacity-10 font-outfit capitalize'}
        ${status === 'completed' && 'bg-green-600 text-green-800 bg-opacity-10 font-outfit capitalize'}
        `}>{unSlugify(status?.toLowerCase())}</span>
    )
}

export default StatusPill